import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { filter, firstValueFrom, take } from "rxjs";

export const rootGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await firstValueFrom(auth.isLoading$.pipe(filter((loading) => !loading), take(1)));

  const isAuthenticated = await firstValueFrom(auth.isAuthenticated$.pipe(take(1)));

  if (isAuthenticated) {
    return router.createUrlTree(["/select-business"]);
  }

  const deniedMessage = sessionStorage.getItem("auth_denied_message");
  sessionStorage.removeItem("auth_denied_message");

  const loginHint = new URLSearchParams(window.location.search).get("login_hint");

  const authorizationParams = {
    ...(deniedMessage ? { access_denied_message: deniedMessage } : {}),
    ...(loginHint ? { login_hint: loginHint } : {}),
  };

  try {
    await firstValueFrom(
      auth.loginWithRedirect({
        authorizationParams: Object.keys(authorizationParams).length ? (authorizationParams as any) : undefined,
      })
    );
  } catch {
    return true;
  }
  return false;
};
